/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import lin11_5_03_FeatureDependencies from '../assets/MSTR11_5_03/LINUX/Lin21FeatureDependencies.json';
import lin11_4_12_FeatureDependencies from '../assets/MSTR11_4_12/LINUX/Lin21FeatureDependencies.json';
import lin11_4_09_FeatureDependencies from '../assets/MSTR11_4_09/LINUX/Lin21FeatureDependencies.json';
import lin11_4_06_FeatureDependencies from '../assets/MSTR11_4_06/LINUX/Lin21FeatureDependencies.json';
import lin11_4_03_FeatureDependencies from '../assets/MSTR11_4_03/LINUX/Lin21FeatureDependencies.json';
import lin11_3_12_FeatureDependencies from '../assets/MSTR11_3_12/LINUX/Lin21FeatureDependencies.json';
import lin11_3_11_FeatureDependencies from '../assets/MSTR11_3_11/LINUX/Lin21FeatureDependencies.json';
import lin11_3_10_FeatureDependencies from '../assets/MSTR11_3_10/LINUX/Lin21FeatureDependencies.json';
import lin11_3_9_FeatureDependencies from '../assets/MSTR11_3_9/LINUX/Lin21FeatureDependencies.json';
import lin11_3_8_FeatureDependencies from '../assets/MSTR11_3_8/LINUX/Lin21FeatureDependencies.json';
import lin11_3_7_FeatureDependencies from '../assets/MSTR11_3_7/LINUX/Lin21FeatureDependencies.json';
import lin11_3_6_FeatureDependencies from '../assets/MSTR11_3_6/LINUX/Lin21FeatureDependencies.json';
import lin11_3_5_FeatureDependencies from '../assets/MSTR11_3_5/LINUX/Lin21FeatureDependencies.json';
import lin11_3_4_FeatureDependencies from '../assets/MSTR11_3_4/LINUX/Lin21FeatureDependencies.json';
import lin21FeatureDependencies from '../assets/MSTR2021/LINUX/Lin21FeatureDependencies.json';

import {
    featureDirectory2StateMap as lin11_5_03_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_5_03_FeatureKey2StateMap,
} from '../assets/MSTR11_5_03/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_4_12_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_4_12_FeatureKey2StateMap,
} from '../assets/MSTR11_4_12/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_4_09_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_4_09_FeatureKey2StateMap,
} from '../assets/MSTR11_4_09/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_4_06_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_4_06_FeatureKey2StateMap,
} from '../assets/MSTR11_4_06/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_4_03_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_4_03_FeatureKey2StateMap,
} from '../assets/MSTR11_4_03/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_12_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_12_FeatureKey2StateMap,
} from '../assets/MSTR11_3_12/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_11_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_11_FeatureKey2StateMap,
} from '../assets/MSTR11_3_11/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_10_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_10_FeatureKey2StateMap,
} from '../assets/MSTR11_3_10/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_9_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_9_FeatureKey2StateMap,
} from '../assets/MSTR11_3_9/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_8_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_8_FeatureKey2StateMap,
} from '../assets/MSTR11_3_8/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_7_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_7_FeatureKey2StateMap,
} from '../assets/MSTR11_3_7/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_6_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_6_FeatureKey2StateMap,
} from '../assets/MSTR11_3_6/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_5_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_5_FeatureKey2StateMap,
} from '../assets/MSTR11_3_5/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_3_4_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_3_4_FeatureKey2StateMap,
} from '../assets/MSTR11_3_4/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin21FeatureDirectory2StateMap,
    featureKey2StateMap as lin21FeatureKey2StateMap,
} from '../assets/MSTR2021/LINUX/Lin21Maps';

import lin11_5_03_Comment from '../assets/MSTR11_5_03/LINUX/Lin21GeneratorComment';
import lin11_4_12_Comment from '../assets/MSTR11_4_12/LINUX/Lin21GeneratorComment';
import lin11_4_09_Comment from '../assets/MSTR11_4_09/LINUX/Lin21GeneratorComment';
import lin11_4_06_Comment from '../assets/MSTR11_4_06/LINUX/Lin21GeneratorComment';
import lin11_4_03_Comment from '../assets/MSTR11_4_03/LINUX/Lin21GeneratorComment';
import lin11_3_12_Comment from '../assets/MSTR11_3_12/LINUX/Lin21GeneratorComment';
import lin11_3_11_Comment from '../assets/MSTR11_3_11/LINUX/Lin21GeneratorComment';
import lin11_3_10_Comment from '../assets/MSTR11_3_10/LINUX/Lin21GeneratorComment';
import lin11_3_9_Comment from '../assets/MSTR11_3_9/LINUX/Lin21GeneratorComment';
import lin11_3_8_Comment from '../assets/MSTR11_3_8/LINUX/Lin21GeneratorComment';
import lin11_3_7_Comment from '../assets/MSTR11_3_7/LINUX/Lin21GeneratorComment';
import lin11_3_6_Comment from '../assets/MSTR11_3_6/LINUX/Lin21GeneratorComment';
import lin11_3_5_Comment from '../assets/MSTR11_3_5/LINUX/Lin21GeneratorComment';
import lin11_3_4_Comment from '../assets/MSTR11_3_4/LINUX/Lin21GeneratorComment';
import lin21Comment from '../assets/MSTR2021/LINUX/Lin21GeneratorComment';
import lin21Update1Comment from '../assets/MSTR2021/LINUX_UPDATES/Lin21Update1GeneratorComment';

import {
    state2PrefixMap as lin11_5_03_State2PrefixMap,
    state2CommentMap as lin11_5_03_State2CommentMap,
} from '../assets/MSTR11_5_03/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_4_12_State2PrefixMap,
    state2CommentMap as lin11_4_12_State2CommentMap,
} from '../assets/MSTR11_4_12/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_4_09_State2PrefixMap,
    state2CommentMap as lin11_4_09_State2CommentMap,
} from '../assets/MSTR11_4_09/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_4_06_State2PrefixMap,
    state2CommentMap as lin11_4_06_State2CommentMap,
} from '../assets/MSTR11_4_06/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_4_03_State2PrefixMap,
    state2CommentMap as lin11_4_03_State2CommentMap,
} from '../assets/MSTR11_4_03/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_12_State2PrefixMap,
    state2CommentMap as lin11_3_12_State2CommentMap,
} from '../assets/MSTR11_3_12/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_11_State2PrefixMap,
    state2CommentMap as lin11_3_11_State2CommentMap,
} from '../assets/MSTR11_3_11/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_10_State2PrefixMap,
    state2CommentMap as lin11_3_10_State2CommentMap,
} from '../assets/MSTR11_3_10/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_9_State2PrefixMap,
    state2CommentMap as lin11_3_9_State2CommentMap,
} from '../assets/MSTR11_3_9/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_8_State2PrefixMap,
    state2CommentMap as lin11_3_8_State2CommentMap,
} from '../assets/MSTR11_3_8/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_7_State2PrefixMap,
    state2CommentMap as lin11_3_7_State2CommentMap,
} from '../assets/MSTR11_3_7/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_6_State2PrefixMap,
    state2CommentMap as lin11_3_6_State2CommentMap,
} from '../assets/MSTR11_3_6/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_5_State2PrefixMap,
    state2CommentMap as lin11_3_5_State2CommentMap,
} from '../assets/MSTR11_3_5/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_3_4_State2PrefixMap,
    state2CommentMap as lin11_3_4_State2CommentMap,
} from '../assets/MSTR11_3_4/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin21State2PrefixMap,
    state2CommentMap as lin21State2CommentMap,
} from '../assets/MSTR2021/LINUX/Lin21Maps4Generator';
import {
    state2PrefixMap as lin21Update1State2PrefixMap,
    state2CommentMap as lin21Update1State2CommentMap,
} from '../assets/MSTR2021/LINUX_UPDATES/Lin21Update1Maps4Generator';

import lin11_5_03_PageObjects from '../assets/MSTR11_5_03/LINUX/Lin21PageObjects.json';
import lin11_4_12_PageObjects from '../assets/MSTR11_4_12/LINUX/Lin21PageObjects.json';
import lin11_4_09_PageObjects from '../assets/MSTR11_4_09/LINUX/Lin21PageObjects.json';
import lin11_4_06_PageObjects from '../assets/MSTR11_4_06/LINUX/Lin21PageObjects.json';
import lin11_4_03_PageObjects from '../assets/MSTR11_4_03/LINUX/Lin21PageObjects.json';
import lin11_3_12_PageObjects from '../assets/MSTR11_3_12/LINUX/Lin21PageObjects.json';
import lin11_3_11_PageObjects from '../assets/MSTR11_3_11/LINUX/Lin21PageObjects.json';
import lin11_3_10_PageObjects from '../assets/MSTR11_3_10/LINUX/Lin21PageObjects.json';
import lin11_3_9_PageObjects from '../assets/MSTR11_3_9/LINUX/Lin21PageObjects.json';
import lin11_3_8_PageObjects from '../assets/MSTR11_3_8/LINUX/Lin21PageObjects.json';
import lin11_3_7_PageObjects from '../assets/MSTR11_3_7/LINUX/Lin21PageObjects.json';
import lin11_3_6_PageObjects from '../assets/MSTR11_3_6/LINUX/Lin21PageObjects.json';
import lin11_3_5_PageObjects from '../assets/MSTR11_3_5/LINUX/Lin21PageObjects.json';
import lin11_3_4_PageObjects from '../assets/MSTR11_3_4/LINUX/Lin21PageObjects.json';
import lin21PageObjects from '../assets/MSTR2021/LINUX/Lin21PageObjects.json';
import lin21Update1PageObjects from '../assets/MSTR2021/LINUX_UPDATES/Lin21Update1PageObjects.json';

import lin11_5_03_States from '../assets/MSTR11_5_03/LINUX/Lin21States.json';
import lin11_4_12_States from '../assets/MSTR11_4_12/LINUX/Lin21States.json';
import lin11_4_09_States from '../assets/MSTR11_4_09/LINUX/Lin21States.json';
import lin11_4_06_States from '../assets/MSTR11_4_06/LINUX/Lin21States.json';
import lin11_4_03_States from '../assets/MSTR11_4_03/LINUX/Lin21States.json';
import lin11_3_12_States from '../assets/MSTR11_3_12/LINUX/Lin21States.json';
import lin11_3_11_States from '../assets/MSTR11_3_11/LINUX/Lin21States.json';
import lin11_3_10_States from '../assets/MSTR11_3_10/LINUX/Lin21States.json';
import lin11_3_9_States from '../assets/MSTR11_3_9/LINUX/Lin21States.json';
import lin11_3_8_States from '../assets/MSTR11_3_8/LINUX/Lin21States.json';
import lin11_3_7_States from '../assets/MSTR11_3_7/LINUX/Lin21States.json';
import lin11_3_6_States from '../assets/MSTR11_3_6/LINUX/Lin21States.json';
import lin11_3_5_States from '../assets/MSTR11_3_5/LINUX/Lin21States.json';
import lin11_3_4_States from '../assets/MSTR11_3_4/LINUX/Lin21States.json';
import lin21States from '../assets/MSTR2021/LINUX/Lin21States.json';
import lin21Update1States from '../assets/MSTR2021/LINUX_UPDATES/Lin21Update1States.json';

import lin11_5_03_SummaryStructure from '../assets/MSTR11_5_03/LINUX/Lin21SummaryStructure.json';
import lin11_4_12_SummaryStructure from '../assets/MSTR11_4_12/LINUX/Lin21SummaryStructure.json';
import lin11_4_09_SummaryStructure from '../assets/MSTR11_4_09/LINUX/Lin21SummaryStructure.json';
import lin11_4_06_SummaryStructure from '../assets/MSTR11_4_06/LINUX/Lin21SummaryStructure.json';
import lin11_4_03_SummaryStructure from '../assets/MSTR11_4_03/LINUX/Lin21SummaryStructure.json';
import lin11_3_12_SummaryStructure from '../assets/MSTR11_3_12/LINUX/Lin21SummaryStructure.json';
import lin11_3_11_SummaryStructure from '../assets/MSTR11_3_11/LINUX/Lin21SummaryStructure.json';
import lin11_3_10_SummaryStructure from '../assets/MSTR11_3_10/LINUX/Lin21SummaryStructure.json';
import lin11_3_9_SummaryStructure from '../assets/MSTR11_3_9/LINUX/Lin21SummaryStructure.json';
import lin11_3_8_SummaryStructure from '../assets/MSTR11_3_8/LINUX/Lin21SummaryStructure.json';
import lin11_3_7_SummaryStructure from '../assets/MSTR11_3_7/LINUX/Lin21SummaryStructure.json';
import lin11_3_6_SummaryStructure from '../assets/MSTR11_3_6/LINUX/Lin21SummaryStructure.json';
import lin11_3_5_SummaryStructure from '../assets/MSTR11_3_5/LINUX/Lin21SummaryStructure.json';
import lin11_3_4_SummaryStructure from '../assets/MSTR11_3_4/LINUX/Lin21SummaryStructure.json';
import lin21SummaryStructure from '../assets/MSTR2021/LINUX/Lin21SummaryStructure.json';

import {
    LINUX_11_5_03,
    LINUX_11_4_12,
    LINUX_11_4_09,
    LINUX_11_4_06,
    LINUX_11_4_03,  
    LINUX_11_3_12,    
    LINUX_11_3_11,
    LINUX_11_3_10,
    LINUX_11_3_9,
    LINUX_11_3_8,
    LINUX_11_3_7,
    LINUX_11_3_6,
    LINUX_11_3_5_2,
    LINUX_11_3_5_1,
    LINUX_11_3_5,
    LINUX_11_3_4_1,
    LINUX_11_3_4,
    LINUX_21,
    LINUX_21_UPDATE1,
    LINUX_21_UPDATE2,
    LINUX_21_UPDATE3,
} from './Constants';

export let featureDependencies; // Only for GA, not update
export let comment;
export let featureDirectory2StateMap; // Only for GA, not update
export let featureKey2StateMap; // Only for GA, not update
export let state2PrefixMap;
export let state2CommentMap;
export let pageObjects;
export let states;
export let summaryStructure; // Only for GA, not update

export const linLoadData = (installation) => {
    switch (installation) {
        case LINUX_11_5_03:
            featureDependencies = lin11_5_03_FeatureDependencies;
            comment = lin11_5_03_Comment;
            featureDirectory2StateMap = lin11_5_03_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_5_03_FeatureKey2StateMap;
            state2PrefixMap = lin11_5_03_State2PrefixMap;
            state2CommentMap = lin11_5_03_State2CommentMap;
            pageObjects = lin11_5_03_PageObjects;
            states = lin11_5_03_States;
            summaryStructure = lin11_5_03_SummaryStructure;
            break;
        case LINUX_11_4_12:
            featureDependencies = lin11_4_12_FeatureDependencies;
            comment = lin11_4_12_Comment;
            featureDirectory2StateMap = lin11_4_12_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_4_12_FeatureKey2StateMap;
            state2PrefixMap = lin11_4_12_State2PrefixMap;
            state2CommentMap = lin11_4_12_State2CommentMap;
            pageObjects = lin11_4_12_PageObjects;
            states = lin11_4_12_States;
            summaryStructure = lin11_4_12_SummaryStructure;
            break;
        case LINUX_11_4_09:
            featureDependencies = lin11_4_09_FeatureDependencies;
            comment = lin11_4_09_Comment;
            featureDirectory2StateMap = lin11_4_09_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_4_09_FeatureKey2StateMap;
            state2PrefixMap = lin11_4_09_State2PrefixMap;
            state2CommentMap = lin11_4_09_State2CommentMap;
            pageObjects = lin11_4_09_PageObjects;
            states = lin11_4_09_States;
            summaryStructure = lin11_4_09_SummaryStructure;
            break;
        case LINUX_11_4_06:
            featureDependencies = lin11_4_06_FeatureDependencies;
            comment = lin11_4_06_Comment;
            featureDirectory2StateMap = lin11_4_06_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_4_06_FeatureKey2StateMap;
            state2PrefixMap = lin11_4_06_State2PrefixMap;
            state2CommentMap = lin11_4_06_State2CommentMap;
            pageObjects = lin11_4_06_PageObjects;
            states = lin11_4_06_States;
            summaryStructure = lin11_4_06_SummaryStructure;
            break;
        case LINUX_11_4_03:
            featureDependencies = lin11_4_03_FeatureDependencies;
            comment = lin11_4_03_Comment;
            featureDirectory2StateMap = lin11_4_03_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_4_03_FeatureKey2StateMap;
            state2PrefixMap = lin11_4_03_State2PrefixMap;
            state2CommentMap = lin11_4_03_State2CommentMap;
            pageObjects = lin11_4_03_PageObjects;
            states = lin11_4_03_States;
            summaryStructure = lin11_4_03_SummaryStructure;
            break;
        case LINUX_11_3_12:
            featureDependencies = lin11_3_12_FeatureDependencies;
            comment = lin11_3_12_Comment;
            featureDirectory2StateMap = lin11_3_12_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_12_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_12_State2PrefixMap;
            state2CommentMap = lin11_3_12_State2CommentMap;
            pageObjects = lin11_3_12_PageObjects;
            states = lin11_3_12_States;
            summaryStructure = lin11_3_12_SummaryStructure;
            break;        
        case LINUX_11_3_11:
            featureDependencies = lin11_3_11_FeatureDependencies;
            comment = lin11_3_11_Comment;
            featureDirectory2StateMap = lin11_3_11_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_11_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_11_State2PrefixMap;
            state2CommentMap = lin11_3_11_State2CommentMap;
            pageObjects = lin11_3_11_PageObjects;
            states = lin11_3_11_States;
            summaryStructure = lin11_3_11_SummaryStructure;
            break;
        case LINUX_11_3_10:
            featureDependencies = lin11_3_10_FeatureDependencies;
            comment = lin11_3_10_Comment;
            featureDirectory2StateMap = lin11_3_10_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_10_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_10_State2PrefixMap;
            state2CommentMap = lin11_3_10_State2CommentMap;
            pageObjects = lin11_3_10_PageObjects;
            states = lin11_3_10_States;
            summaryStructure = lin11_3_10_SummaryStructure;
            break;
        case LINUX_11_3_9:
            featureDependencies = lin11_3_9_FeatureDependencies;
            comment = lin11_3_9_Comment;
            featureDirectory2StateMap = lin11_3_9_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_9_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_9_State2PrefixMap;
            state2CommentMap = lin11_3_9_State2CommentMap;
            pageObjects = lin11_3_9_PageObjects;
            states = lin11_3_9_States;
            summaryStructure = lin11_3_9_SummaryStructure;
            break;
        case LINUX_11_3_8:
            featureDependencies = lin11_3_8_FeatureDependencies;
            comment = lin11_3_8_Comment;
            featureDirectory2StateMap = lin11_3_8_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_8_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_8_State2PrefixMap;
            state2CommentMap = lin11_3_8_State2CommentMap;
            pageObjects = lin11_3_8_PageObjects;
            states = lin11_3_8_States;
            summaryStructure = lin11_3_8_SummaryStructure;
            break;
        case LINUX_11_3_7:
            featureDependencies = lin11_3_7_FeatureDependencies;
            comment = lin11_3_7_Comment;
            featureDirectory2StateMap = lin11_3_7_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_7_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_7_State2PrefixMap;
            state2CommentMap = lin11_3_7_State2CommentMap;
            pageObjects = lin11_3_7_PageObjects;
            states = lin11_3_7_States;
            summaryStructure = lin11_3_7_SummaryStructure;
            break;
        case LINUX_11_3_6:
            featureDependencies = lin11_3_6_FeatureDependencies;
            comment = lin11_3_6_Comment;
            featureDirectory2StateMap = lin11_3_6_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_6_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_6_State2PrefixMap;
            state2CommentMap = lin11_3_6_State2CommentMap;
            pageObjects = lin11_3_6_PageObjects;
            states = lin11_3_6_States;
            summaryStructure = lin11_3_6_SummaryStructure;
            break;
        case LINUX_11_3_5_2:
        case LINUX_11_3_5_1:
        case LINUX_11_3_5:
            featureDependencies = lin11_3_5_FeatureDependencies;
            comment = lin11_3_5_Comment;
            featureDirectory2StateMap = lin11_3_5_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_5_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_5_State2PrefixMap;
            state2CommentMap = lin11_3_5_State2CommentMap;
            pageObjects = lin11_3_5_PageObjects;
            states = lin11_3_5_States;
            summaryStructure = lin11_3_5_SummaryStructure;
            break;
        case LINUX_11_3_4_1:
        case LINUX_11_3_4:
            featureDependencies = lin11_3_4_FeatureDependencies;
            comment = lin11_3_4_Comment;
            featureDirectory2StateMap = lin11_3_4_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_3_4_FeatureKey2StateMap;
            state2PrefixMap = lin11_3_4_State2PrefixMap;
            state2CommentMap = lin11_3_4_State2CommentMap;
            pageObjects = lin11_3_4_PageObjects;
            states = lin11_3_4_States;
            summaryStructure = lin11_3_4_SummaryStructure;
            break;
        case LINUX_21:
            featureDependencies = lin21FeatureDependencies;
            comment = lin21Comment;
            featureDirectory2StateMap = lin21FeatureDirectory2StateMap;
            featureKey2StateMap = lin21FeatureKey2StateMap;
            state2PrefixMap = lin21State2PrefixMap;
            state2CommentMap = lin21State2CommentMap;
            pageObjects = lin21PageObjects;
            states = lin21States;
            summaryStructure = lin21SummaryStructure;
            break;
        case LINUX_21_UPDATE1:
        case LINUX_21_UPDATE2:
        case LINUX_21_UPDATE3:
            comment = lin21Update1Comment;
            state2PrefixMap = lin21Update1State2PrefixMap;
            state2CommentMap = lin21Update1State2CommentMap;
            pageObjects = lin21Update1PageObjects;
            states = lin21Update1States;
            break;
        default:
    }
};
